var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardBreak"},[_c('h6',{staticClass:"cardBreak__title"},[_vm._v("Receso")]),_c('StopWatch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }